import { getPartnersPartnerIdBalanceTransactions } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const PARTNER_BALANCE = "PARTNER_BALANCE";

export const getPartnerBalanceByPartnerIdQueryKey = (partnerId: number) => {
	return [PARTNER_BALANCE, partnerId];
};

export function usePartnerBalance(partnerId: number) {
	return useQuery({
		queryKey: getPartnerBalanceByPartnerIdQueryKey(partnerId),
		queryFn: processResponse(() =>
			getPartnersPartnerIdBalanceTransactions(partnerId),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
